import { ReactElement } from 'react';

import { ReservationPreference, WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { StyledFlex, TextView } from '@dreryk/react-components';

import { translationKeys } from '../../translations';
import { useNote } from '../confirmReservation.hooks';

type NoteTextViewProps = {
   note?: string;
   patientAvailability: WaitlistEntry['patientAvailability'];
   reservationPreference: ReservationPreference;
};

export const NoteTextView = (props: NoteTextViewProps): ReactElement => {
   const note = useNote(props.note, props.patientAvailability, props.reservationPreference);

   return (
      <TextView testId={'patientAvailability'} label={translationKeys.note}>
         <StyledFlex direction={'column'} gap={'8px'}>
            {note}
         </StyledFlex>
      </TextView>
   );
};
